<template>
    <Modal v-model="isVisibility" :mask-closable="false" :footer-hide="true" class-name="vertical-center-modal diyModal" height="200" width="300" :styles="{top: '33vh'}"  >
        <div>
            <div class="titleStyle">提交成功</div>
            <div class="couponListWrapper">
                <div>您已获得</div>
                <div>
                    <p v-for="(item,id) in awardObj.finalCouponList" :key="id" class="ellipsis">{{item.goodsName}} * 1</p>
                </div>
            </div>
            <p class="defaultGray" style="line-height: 2; margin: 10px 0;">是否跳转到HI荣耀小程序</p>
        </div>
        <div class="btn-tool align-center form-coupon-btn">
            <div class="modalCancel" @click="modalCancel()">取消</div>
            <div class="modalBtn" v-if="loginType == 'wechat'"  @click="miniWechatGo">
              确定
              <div v-html="wxOpenLaunchWeapp" class="wxOpenLaunchWeapp"></div>
            </div>

            <div class="modalBtn" @click="modalOk()" v-if="loginType == 'Alipay'">确定</div>
        </div>
    </Modal>
</template>

<script>
import wx from 'weixin-js-sdk';
import {config as configEnv} from '../../../../../commons/config.js';
import { loadAlipayWebViewScript } from '../../../../../utils/comUtils.js';
import { config } from '@/api/config.js';
export default {
    props: {
        awardObj: Object
    },
    data(){
        return{
            isVisibility:false,
            loginType: "",
            wxOpenLaunchWeapp: "",
            envVersion: configEnv.env === 'pro' ? 'release' : 'trial',
            hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
        }
    },
    created() {
      this.loginType = sessionStorage.getItem('loginType');

      let that = this;

      if(this.loginType == 'wechat') {
        //判断是否在微信小程序环境
        wx.miniProgram.getEnv(function(res) {
          console.log("微信小程序", res.miniprogram);
          if(res.miniprogram){
            that.miniprogramFlag = res.miniprogram;
          }
        });
      }

      loadAlipayWebViewScript().then(res => {
        if(res) {
          //判断是否运行在支付宝小程序环境里
          my.getEnv(function(res){
            console.log("支付宝小程序", res.miniprogram); //true
            if(res.miniprogram) {
              that.miniprogramFlag = res.miniprogram;
            }
          });
        }
      });

        setTimeout(() => {
          if(!this.miniprogramFlag) {
            this.wxOpenLaunchWeapp = `<wx-open-launch-weapp id="launch-btn" username=${this.hiHonorWxAppId} env-version=${this.envVersion} path="subpackages/my/pages/couponList/coupon-list"><template><style>.btn { width: 1000px;height: 100px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
          }
        }, 500);
    },
    methods:{
        openModel(){
            this.isVisibility=true
        },

        modalCancel(){
            this.isVisibility=false;
            this.$emit('confirmModal');
        },

        modalOk() {
          if(this.miniprogramFlag) {
            my.redirectTo({
              url: '/subpackages/my/pages/couponList/coupon-list'
            })
          } else {
            window.location.href="alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/couponList/coupon-list";
          }
        },
        miniWechatGo() {
          if(this.miniprogramFlag) {
            wx.miniProgram.navigateTo({
              url: '/subpackages/my/pages/couponList/coupon-list',
              success: function(){
                console.log('跳转回小程序的页面success')
              },
              fail: function(){
                console.log('跳转回小程序的页面fail');
              },
            })
          }
        }
    },
}
</script>

<style>
    .diyModal .ivu-modal {
        width: 75% !important;
        margin: auto;
    }
    .diyModal .ivu-modal-body {
        text-align: center;
        font-size: 14px;
    }
    .titleStyle {
        color: #2592F7;
        font-size: 16px;
        font-size: 18px;
        margin-bottom: 5px;
    }
    .defaultGray {
        color: #666666;
    }

    .form-coupon-btn {
      display: flex;
      justify-content: space-between;
    }
        /* background-image: linear-gradient(102deg, #5196FE 0%, #2C71FE 81%); */

    .modalBtn {
        border-radius: 48px;
        /* color: #fff; */
        width: 45%;
        height: 36px;
        margin-top: 5px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .wxOpenLaunchWeapp {
        width: 100%;
        height: 100%;
        position:absolute;
        top: 0;
    }

    .modalCancel {
        border: 1px solid #2C71FE;
        background: #00000008;
        border-radius: 48px;
        color: #2C71FE;
        width: 45%;
        height: 36px;
        margin-top: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .couponListWrapper {
        margin-top: 20px;
    }
    .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
    }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/form-coupon-modal.vue